import { useState, useCallback } from 'react';

/**
 * useK1Manager
 *
 * Owns the K1-manager state that was previously class state on FormViewer:
 *
 *   handleChangeHideK1s(flag) — update hideK1Flag
 *   handleToggleK1ManagerModal(toggle) — save hide preference then toggle Redux modal
 *
 * State returned for render:
 *   k1List     — array of K1 objects
 *   k1pkgList  — array of K1 package objects
 *   hideK1Flag — boolean hide flag
 *
 * Callers must supply:
 *   calcAPIRef         — ref to CalcAPI instance
 *   onToggleK1Manager  — Redux action (props.toggleK1ManagerModal)
 */
const useK1Manager = ({ calcAPIRef, onToggleK1Manager }) => {
  const [k1List, setK1List] = useState([]);
  const [k1pkgList, setK1pkgList] = useState([]);
  const [hideK1Flag, setHideK1Flag] = useState('');

  const handleChangeHideK1s = useCallback(flag => {
    setHideK1Flag(flag);
  }, []);

  const handleToggleK1ManagerModal = useCallback(
    toggle => {
      // 0 = show, 1 = do not show, see corpnav :NAVLINE
      calcAPIRef.current?.ReturnHideK1s(hideK1Flag ? '1' : '0');
      onToggleK1Manager(toggle);
    },
    [calcAPIRef, hideK1Flag, onToggleK1Manager],
  );

  return {
    k1List,
    setK1List,
    k1pkgList,
    setK1pkgList,
    hideK1Flag,
    setHideK1Flag,
    handleChangeHideK1s,
    handleToggleK1ManagerModal,
  };
};

export default useK1Manager;
